import AbstractInstaller from "../../app/core/AbstractInstaller";
import InitDebugToolsTask from "./connector/InitDebugToolsTask";

export default class DebugToolsInstaller extends AbstractInstaller {


    constructor(injector, commands, mediatorMap) {
        super(injector, commands, mediatorMap);

        //startup tasks:
        this._addStartupTask(InitDebugToolsTask, "InitDebugTools");
    }
}